export const useSmoothScroll = () => {
  const scrollToElement = (elementId: string) => {
    const element = document.querySelector(elementId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return {
    scrollToElement,
    scrollToTop,
  }
}
